import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Instagram, Facebook, Twitter, FileText } from 'lucide-react';
import { COMPANY } from '../lib/company';

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-neutral-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <span className="font-serif text-3xl font-bold text-white tracking-tight">AXA</span>
          <p className="mt-4 text-sm text-neutral-400 leading-relaxed max-w-xs">
            Genți din piele naturală, ceasuri și accesorii pentru un stil complet.
          </p>
          <div className="flex items-center gap-2 mt-6">
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 hover:bg-white hover:text-neutral-900 transition-colors flex items-center justify-center"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 hover:bg-white hover:text-neutral-900 transition-colors flex items-center justify-center"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 hover:bg-white hover:text-neutral-900 transition-colors flex items-center justify-center"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 text-sm">Magazin</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            <li><Link to="/magazin" className="hover:text-white transition-colors">Toate produsele</Link></li>
            <li><Link to="/categorie/genti" className="hover:text-white transition-colors">Genți</Link></li>
            <li><Link to="/categorie/ceasuri" className="hover:text-white transition-colors">Ceasuri</Link></li>
            <li><Link to="/favorite" className="hover:text-white transition-colors">Favorite</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 text-sm">Informații</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            <li><Link to="/termeni-si-conditii" className="hover:text-white transition-colors">Termeni și Condiții</Link></li>
            <li><Link to="/livrare" className="hover:text-white transition-colors">Livrare și plată</Link></li>
            <li><Link to="/retur" className="hover:text-white transition-colors">Politica de retur</Link></li>
            <li><Link to="/confidentialitate" className="hover:text-white transition-colors">Confidențialitate</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-4 text-sm">Contact</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{COMPANY.sediu}</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 shrink-0" />
              <a href={`tel:${COMPANY.phoneClean}`} className="hover:text-white">{COMPANY.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Date firmă oficiale */}
      <div className="border-t border-neutral-900 bg-black/40">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6">
          <div className="flex items-center gap-2 mb-3">
            <FileText className="w-4 h-4 text-neutral-400" />
            <h4 className="text-xs uppercase tracking-wider text-neutral-300 font-semibold">Date firmă</h4>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-xs">
            <div>
              <div className="text-neutral-500 uppercase tracking-wider text-[10px]">Denumire</div>
              <div className="text-neutral-200 mt-0.5 font-medium">{COMPANY.name}</div>
            </div>
            <div>
              <div className="text-neutral-500 uppercase tracking-wider text-[10px]">CUI</div>
              <div className="text-neutral-200 mt-0.5 font-mono">{COMPANY.cui}</div>
            </div>
            <div>
              <div className="text-neutral-500 uppercase tracking-wider text-[10px]">Nr. Registru Comerțului</div>
              <div className="text-neutral-200 mt-0.5 font-mono">{COMPANY.regCom}</div>
            </div>
            <div>
              <div className="text-neutral-500 uppercase tracking-wider text-[10px]">EUID</div>
              <div className="text-neutral-200 mt-0.5 font-mono text-[11px]">{COMPANY.euid}</div>
            </div>
          </div>
        </div>
      </div>

      {/* ANPC */}
      <div className="border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="text-xs text-neutral-400 max-w-md text-center md:text-left">
            <p className="font-semibold text-neutral-200 mb-1">Protecția consumatorilor</p>
            <p>
              Conform legislației în vigoare, vă informăm despre drepturile dumneavoastră ca și consumator
              și posibilitatea de soluționare a litigiilor pe cale amiabilă.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://anpc.ro/ce-este-sal/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              aria-label="ANPC - Soluționarea Alternativă a Litigiilor"
              className="block bg-white rounded-lg p-1.5 hover:shadow-lg transition-shadow"
            >
              <img
                src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sal.svg"
                alt="ANPC - Soluționarea Alternativă a Litigiilor"
                className="h-12 w-auto block"
                style={{ width: 'auto', maxWidth: '250px' }}
                loading="lazy"
              />
            </a>
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer nofollow"
              aria-label="ANPC - Soluționarea Online a Litigiilor"
              className="block bg-white rounded-lg p-1.5 hover:shadow-lg transition-shadow"
            >
              <img
                src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sol.svg"
                alt="ANPC - Soluționarea Online a Litigiilor"
                className="h-12 w-auto block"
                style={{ width: 'auto', maxWidth: '250px' }}
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-neutral-500 text-center md:text-left">
            © {new Date().getFullYear()} {COMPANY.name} — Toate drepturile rezervate. · CUI {COMPANY.cui} · {COMPANY.regCom}
          </p>
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-neutral-500">
            <span className="px-2.5 py-1 border border-neutral-800 rounded">VISA</span>
            <span className="px-2.5 py-1 border border-neutral-800 rounded">Mastercard</span>
            <span className="px-2.5 py-1 border border-neutral-800 rounded">Ramburs</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
